import { Injectable, Inject } from '@angular/core';
import { HttpEvent, HttpRequest, HttpHandler, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

import { environment } from '@environments/environment'
import { catchError, mergeMap } from 'rxjs/operators';
import { ConfigurationServiceInterface } from '@interfaces/configuration-service.interface';
import { TableStorageServiceInterface } from '@interfaces/table-storage.interface';

@Injectable()
export class ConfiUriInterceptor<T> implements HttpInterceptor {

    constructor(
        @Inject('TableStorageService') private tableStorageService: TableStorageServiceInterface<T>,
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        //console.log(request.url)
        if (request.url == environment.graphApiToken) {
            return next.handle(request);
        }
        if (request.url.indexOf(environment.apiUrl) > -1 || request.url.indexOf(environment.graphApiURL) > -1) {
            return this.getTokenConfig(false, next, request)
                .pipe(
                    catchError((error: HttpErrorResponse) => {
                        // this.tableStorageService.loggerErrorHttp(error)
                        if (error && error.status === 403) {
                            return this.getTokenConfig(true, next, request)
                        }
                        return throwError(error);
                    })
                )
        }
        return next.handle(request);
    }

    private getTokenConfig(isExpired: boolean, next: HttpHandler, request: HttpRequest<any>): Observable<HttpEvent<any>> {
        return this.tableStorageService
            .getToken$(isExpired)
            .pipe(
                mergeMap(token => next.handle(
                    this.addAuthenticationToken(token, request)
                )),
            )
    }
    private addAuthenticationToken(token: string, request: HttpRequest<any>): HttpRequest<any> {
        const tokenData = token.slice(1, token.length)
        //console.log(request.url.indexOf(environment.graphApiURL))
        let username = "signature_manager";
        let password = "Eafit2021*";
        let authorizationData = 'Basic ' + btoa(username + ':' + password);
        if (request.url.indexOf(environment.graphApiURL) > -1) {
            authorizationData = `Bearer ${tokenData}`;
        }
        let headers: { [name: string]: string | string[] } = {
            ['Content-Type']: 'application/json;odata=nometadata',
            ['Accept']: 'application/json',
            ['Access-Control-Allow-Origin']: '*',
            ['Access-Control-Allow-Headers']: 'Authorization, X-API-KEY, Origin, X-Requested-With, Content-Type, Accept, Access-Control-Allow-Request-Method',
            ['Access-Control-Allow-Methods']: 'DELETE, POST, PUT, GET, OPTIONS',
            ['Allow']: 'GET, POST, OPTIONS, PUT, DELETE, X-API-KEY, Origin, X-Requested-With, Content-Type, Accept, Access-Control-Request-Method',
            ['Authorization']: authorizationData,
            //['Authorization']: `Bearer ${tokenData}`,
            //['Ocp-Apim-Subscription-Key']: '727423652990415a912bb212d79581d4'
        }
        /* let url = `${request.url}&${tokenData}` */
        let url = `${request.url}`
        if (request.method === 'GET' || request.method === 'POST' || request.method === 'PUT' || request.method === 'DELETE') {
            /* url = `${request.url}?${tokenData}` */
            url = `${request.url}`
        }
        /*
        else if(request.method === 'DELETE'){
            url = `${request.url}`
            headers = {
                ...headers,
                ['If-Match']: '*'
            }
        }*/
        return request.clone({
            url,
            setHeaders: headers
        });
    }
}